import {
    capturePurchaseDispatchAuthorization,
    hasPurchaseDispatchAuthorization,
} from '~/assets/js/purchaseEventDedup'

let digitsRE = /(\d{3})(?=\d)/g

export function convertCurrency(value, prefix = 'R$ ', decimals = 2) {
    // Garantir que o valor seja um número
    value = parseFloat(value);

    // Se não for um número válido, retornar zero formatado
    if (isNaN(value)) {
        value = 0;
    }

    // Formatar o valor com a precisão decimal especificada
    const formattedValue = value.toLocaleString('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });

    // Retornar o valor formatado com o prefixo (se especificado)
    return formattedValue;
}

// export function calcInterests(amount, tax, installments) {
//     var juros =
//         amount *
//         (tax / 100) *
//         (installments > 1 ? installments : installments - 1)
//     var montante = amount + juros

//     var result = {
//         amount_input: parseInt(amount),
//         tax_interest: tax,
//         amount_tax: parseInt(juros),
//         amount_final: parseInt(montante),
//         amount_installment: parseInt(montante / installments),
//     }


//     return result
// }

// NOVO BASEADO COMPETIDORES
// export function calcInterests(a, tax = 2.99, installments) {
//     var taxa_parcelamento = tax / 100;

//     var o = installments > 1 ? installments : 1
//     let installments_amount_juros = 0;

//     if (o > 1) {
//         installments_amount_juros = Number(
//             a / ((1 - Math.pow(1 + taxa_parcelamento, -o)) / taxa_parcelamento)
//         ).toFixed(2)
//     } else {
//         installments_amount_juros = a;
//     }

//     installments_amount_juros = parseFloat(installments_amount_juros);

//     var result = {
//         amount_input: parseInt(a),
//         tax_interest: tax * 100,
//         amount_tax: parseInt(installments * installments_amount_juros - a),
//         amount_final: parseInt(installments * installments_amount_juros),
//         amount_installment: parseInt(installments_amount_juros),
//     }

//     return result;
// }


// Juros totais (%) da parcela na tabela do gateway (installment_interest_rates), ou null
// quando a parcela não está na tabela e valem os juros ao mês (custom_interest).
export function getInstallmentTableRate(installment_rates, installments) {
    if (!installment_rates || typeof installment_rates !== 'object') {
        return null;
    }

    const rate = installment_rates[installments];

    if (rate === null || rate === undefined || rate === '' || isNaN(Number(rate))) {
        return null;
    }

    return Number(rate);
}

export function calcInterests(a, tax = 0, installments, free_installments = 1, installment_rates = null) {
    const table_rate = getInstallmentTableRate(installment_rates, installments);

    if (installments > 1 && free_installments < installments) {
        // Tabela: mesma conta do EstimatePaymentController da API, em inteiros (centavos ×
        // centésimos de %), para o valor exibido ser exatamente o cobrado, sem diferença de
        // arredondamento de ponto flutuante entre JS e PHP.
        var juros = table_rate !== null
            ? Math.floor((a * Math.round(table_rate * 100) + 5000) / 10000)
            : (a * ((tax / 100) * installments));
    } else {
        var juros = 0;
    }

    var montante = a + juros;

    var result = {
        installments: installments,
        amount_input: parseInt(a),
        tax_interest: tax / 100,
        amount_tax: parseInt(juros),
        amount_final: parseInt(montante),
        amount_installment: parseInt(montante / installments),
    }

    return result;
}

// Parcelas do upsell (tela real e preview do dashboard): 2,99% de juros ao mês a partir da
// 2ª parcela sobre o preço promocional (em centavos), indexadas pelo número da parcela.
export function calcUpsellInstallments(price, max_installments = 12) {
    const amount = parseInt(price, 10) || 0;
    const installments = {};

    for (let a = 1; a <= max_installments; a++) {
        installments[a] = calcInterests(amount, 2.99, a);
    }

    return installments;
}

export function clearString(string) {
    return removeSpaces(string.replace(/[^\w\s]/gi, ''));
}

export function removeSpaces(string) {
    return string.replace(/\s/g, '');
}

export function uniqid(prefix = "", random = false) {
    const sec = Date.now() * 1000 + Math.random() * 1000;
    const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
    return prefix + id + (random ? Math.trunc(Math.random() * 100000000) : "");
}

export function isSameCoupon(a, b) {
    if (!a || !b) return false
    if (a.id != null && b.id != null) return a.id === b.id
    if (a.code && b.code) {
        return String(a.code).toLowerCase() === String(b.code).toLowerCase()
    }
    return false
}

export function mapCouponsForPayload(coupons) {
    return (Array.isArray(coupons) ? coupons : [])
        .filter((c) => c && typeof c === 'object' && (c.id != null || c.code))
        .map((c) => ({
            id: c.id ?? null,
            code: c.code ?? null,
        }))
}

/**
 * Aplica cupom automático sem substituir cupons já acumulados.
 * Retorna true quando o cupom foi de fato inserido na lista.
 */
export function applyAutomaticCoupon(store, coupon) {
    if (!store || !coupon || typeof coupon !== 'object') return false

    const removedIds = store.state.removedAutomaticCouponIds || []
    const idToBlock = coupon.id != null ? coupon.id : coupon.code
    if (idToBlock != null && removedIds.includes(idToBlock)) return false

    const applied = store.getters['getCoupons'] || []
    if (applied.some((c) => isSameCoupon(c, coupon))) return false

    store.commit('appendCoupon', coupon)
    return true
}

export function commitTransactionCoupons(store, data) {
    if (!store || !data) return

    const list = Array.isArray(data.coupons) && data.coupons.length > 0
        ? data.coupons.filter((c) => c && typeof c === 'object' && (c.id != null || c.code))
        : (data.coupon && typeof data.coupon === 'object' && (data.coupon.id != null || data.coupon.code)
            ? [data.coupon]
            : [])

    if (!list.length) return

    store.commit('setCoupon', list[0])
    list.slice(1).forEach((c) => store.commit('appendCoupon', c))
}

/**
 * Reativa Purchase na /customer/:hash só quando esta sessão confirmou o pagamento
 * (redirect do checkout ou polling). Pedido já pago aberto depois não dispara.
 * Não consulta a flag de nenhuma plataforma: cada uma deduplica sozinha
 * (purchase_event_fired_<hash>_<plataforma>), então quem já disparou ignora o
 * re-arme e quem ainda não disparou (ex.: Google Ads/GA esperando "paid") ganha a vez.
 */
export function shouldRearmPurchaseEventOnCustomerPage(transaction) {
    if (!transaction || transaction.payment_status == null) {
        return false
    }
    const status = parseInt(transaction.payment_status, 10)
    if (Number.isNaN(status) || status === 7) {
        return false
    }
    const method = parseInt(transaction.payment_method, 10)
    if (Number.isNaN(method)) {
        return false
    }
    const hash = transaction.hash
    if (!hash) {
        return false
    }
    if (method === 1 && status !== 3) {
        return false
    }
    if ((method === 2 || method === 3) && status !== 5 && status !== 3) {
        return false
    }
    if (method !== 1 && method !== 2 && method !== 3) {
        return false
    }
    capturePurchaseDispatchAuthorization(hash)
    return hasPurchaseDispatchAuthorization(hash)
}

/**
 * Propaga query params da URL atual (ex.: utm_*) para o destino,
 * sem sobrescrever parâmetros já presentes.
 */
export function appendQueryParamsToUrl(url, query = {}) {
    if (!query || Object.keys(query).length === 0) {
        return url
    }

    if (typeof window === 'undefined') {
        return url
    }

    try {
        const destination = new URL(url, window.location.origin)

        Object.entries(query).forEach(([key, value]) => {
            if (value == null || value === '') {
                return
            }

            if (!destination.searchParams.has(key)) {
                destination.searchParams.set(key, String(value))
            }
        })

        return destination.toString()
    } catch (_) {
        const params = new URLSearchParams()

        Object.entries(query).forEach(([key, value]) => {
            if (value != null && value !== '') {
                params.set(key, String(value))
            }
        })

        const queryString = params.toString()

        if (!queryString) {
            return url
        }

        const separator = url.includes('?') ? '&' : '?'
        return `${url}${separator}${queryString}`
    }
}

/**
 * Normaliza `shipping.states` (array ou JSON string).
 * Fretes com custom_by_state só valem para as UFs listadas.
 */
export function parseShippingStates(states) {
    if (Array.isArray(states)) return states
    if (typeof states === 'string' && states.trim() !== '') {
        try {
            const parsed = JSON.parse(states)
            return Array.isArray(parsed) ? parsed : []
        } catch (e) {
            return []
        }
    }
    return []
}

/**
 * True when Vuex `shipping` is a real option (has id).
 * The store used to default to `{}`, which is truthy and fooled
 * `if (!selectedShipping)` checks — payment went to the API without freight.
 */
export function hasValidShippingSelection(shipping) {
    if (shipping == null || typeof shipping !== 'object' || Array.isArray(shipping)) {
        return false
    }

    return shipping.id != null && String(shipping.id).trim() !== ''
}

export function sameShippingId(a, b) {
    if (a == null || b == null) return false
    return String(a) === String(b)
}

/**
 * Filtra fretes pela UF do cliente (custom_by_state + states).
 * Usado por PageLayout, SinglePageLayout e AiLayoutAdapter.
 */
export function filterShippingsByState(shippings, state) {
    if (!Array.isArray(shippings)) return []
    const customerState = state == null ? '' : String(state).trim().toUpperCase()
    return shippings.filter((shipping) => {
        if (Number(shipping.custom_by_state) !== 1) return true
        if (!customerState) return false
        return parseShippingStates(shipping.states)
            .map((s) => String(s).trim().toUpperCase())
            .includes(customerState)
    })
}

/**
 * Frete marcado no painel como pré-selecionado (`is_default`). A API manda
 * boolean, mas aceita 1/"1" por segurança. Retorna null quando não há.
 */
export function findDefaultShipping(shippings) {
    if (!Array.isArray(shippings)) return null
    return shippings.find((shipping) => {
        if (shipping == null || typeof shipping !== 'object') return false
        return shipping.is_default === true || Number(shipping.is_default) === 1
    }) || null
}

/**
 * Faixas de CEP por UF (Correios): [início, fim, UF] com o CEP em 8 dígitos
 * como número. Usadas para inferir o estado quando a consulta de CEP
 * (ViaCEP/BrasilAPI) falha — os layouts AI Theme não têm campo de UF e sem
 * UF o frete nunca é cotado.
 */
const ZIP_CODE_RANGES_BY_STATE = [
    [1000000, 19999999, 'SP'],
    [20000000, 28999999, 'RJ'],
    [29000000, 29999999, 'ES'],
    [30000000, 39999999, 'MG'],
    [40000000, 48999999, 'BA'],
    [49000000, 49999999, 'SE'],
    [50000000, 56999999, 'PE'],
    [57000000, 57999999, 'AL'],
    [58000000, 58999999, 'PB'],
    [59000000, 59999999, 'RN'],
    [60000000, 63999999, 'CE'],
    [64000000, 64999999, 'PI'],
    [65000000, 65999999, 'MA'],
    [66000000, 68899999, 'PA'],
    [68900000, 68999999, 'AP'],
    [69000000, 69299999, 'AM'],
    [69300000, 69399999, 'RR'],
    [69400000, 69899999, 'AM'],
    [69900000, 69999999, 'AC'],
    [70000000, 72799999, 'DF'],
    [72800000, 72999999, 'GO'],
    [73000000, 73699999, 'DF'],
    [73700000, 76799999, 'GO'],
    [76800000, 76999999, 'RO'],
    [77000000, 77999999, 'TO'],
    [78000000, 78899999, 'MT'],
    [79000000, 79999999, 'MS'],
    [80000000, 87999999, 'PR'],
    [88000000, 89999999, 'SC'],
    [90000000, 99999999, 'RS'],
]

export function zipCodeDigits(zipCode) {
    return String(zipCode ?? '').replace(/\D/g, '').slice(0, 8)
}

/** UF inferida pela faixa de CEP ('' se o CEP for incompleto/fora das faixas). */
export function stateFromZipCode(zipCode) {
    const digits = zipCodeDigits(zipCode)
    if (digits.length !== 8) return ''
    const value = Number(digits)
    const range = ZIP_CODE_RANGES_BY_STATE.find(([start, end]) => value >= start && value <= end)
    return range ? range[2] : ''
}

/**
 * Params que costumam vir DEPOIS de custom_options na URL do checkout.
 * Não incluir utm_source/utm_medium: valores personalizados (ex.: Spotify)
 * frequentemente trazem esses fragmentos sem encode e fazem parte do JSON.
 */
const CUSTOM_OPTIONS_TERMINAL_PARAMS = [
    '_ga',
    '_gl',
    '_upsession',
    'fbclid',
    'gclid',
    'ttclid',
    'wbraid',
    'gbraid',
    'mc_cid',
    'mc_eid',
    'coupon',
    'ch',
    'affh',
    'platform',
    'lock_changes',
    'qtds',
    'preview',
]

function decodeCustomOptionsRaw(raw) {
    const normalized = String(raw || '').replace(/\+/g, ' ')
    try {
        return decodeURIComponent(normalized)
    } catch (_) {
        try {
            return decodeURIComponent(
                normalized.replace(/%(?![0-9A-Fa-f]{2})/g, '%25')
            )
        } catch (__) {
            return normalized
        }
    }
}

/**
 * Lê custom_options direto da querystring, recolocando pedaços cortados por `&`
 * não encoded dentro de valores (ex.: link do Spotify com &utm_source=).
 */
export function getRawCustomOptionsFromSearch(search = '') {
    if (!search || typeof search !== 'string') return null

    const query = search.startsWith('?') ? search.slice(1) : search
    const key = 'custom_options='
    const start = query.indexOf(key)
    if (start === -1) return null

    let raw = query.slice(start + key.length)

    for (const param of CUSTOM_OPTIONS_TERMINAL_PARAMS) {
        const marker = `&${param}=`
        const idx = raw.indexOf(marker)
        if (idx !== -1) {
            raw = raw.slice(0, idx)
        }
    }

    const decoded = decodeCustomOptionsRaw(raw)
    return decoded || null
}

/**
 * Extrai o primeiro objeto JSON (com suporte a strings que contenham `{`/`}`/`&`).
 */
export function extractFirstJSONObject(str) {
    if (!str || typeof str !== 'string') {
        throw new Error('Invalid JSON source')
    }

    const start = str.indexOf('{')
    if (start === -1) {
        throw new Error('JSON object not found')
    }

    let depth = 0
    let inString = false
    let escape = false

    for (let i = start; i < str.length; i++) {
        const c = str[i]

        if (inString) {
            if (escape) {
                escape = false
            } else if (c === '\\') {
                escape = true
            } else if (c === '"') {
                inString = false
            }
            continue
        }

        if (c === '"') {
            inString = true
        } else if (c === '{') {
            depth++
        } else if (c === '}') {
            depth--
            if (depth === 0) {
                return JSON.parse(str.slice(start, i + 1))
            }
        }
    }

    throw new Error('Incomplete JSON object')
}

export function variationIdsMatch(a, b) {
    if (a == null || b == null || a === '' || b === '') return false
    return String(a) === String(b)
}

/**
 * Parseia "variationId:-:{json}::variationId2:-:{json2}" em entradas tipadas.
 */
export function parseCustomOptionsString(customOptionsString) {
    if (!customOptionsString || typeof customOptionsString !== 'string') {
        return []
    }

    return customOptionsString
        .split('::')
        .map((segment) => {
            const trimmed = segment.trim()
            if (!trimmed) return null

            const sep = trimmed.indexOf(':-:')
            if (sep === -1) return null

            const variationId = trimmed.slice(0, sep).trim()
            const payload = trimmed.slice(sep + 3).trim()
            if (!variationId || !payload) return null

            try {
                let options = extractFirstJSONObject(payload)
                if (typeof options === 'string') {
                    options = JSON.parse(options)
                }
                if (!options || typeof options !== 'object' || Array.isArray(options)) {
                    return null
                }

                const cleaned = Object.fromEntries(
                    Object.entries(options).filter(
                        ([, value]) => value !== null && value !== ''
                    )
                )

                if (Object.keys(cleaned).length === 0) return null

                return { variationId, options: cleaned }
            } catch (error) {
                console.warn('Invalid custom_options segment:', payload, error)
                return null
            }
        })
        .filter(Boolean)
}

/**
 * Fonte canônica de custom_options: prioriza window.location.search (repara
 * truncamento por &) e cai no valor do vue-router se necessário.
 */
export function parseCustomOptionsFromLocation(search, routeQueryValue) {
    const candidates = []

    const fromSearch = getRawCustomOptionsFromSearch(search || '')
    if (fromSearch) candidates.push(fromSearch)

    if (typeof routeQueryValue === 'string' && routeQueryValue) {
        candidates.push(routeQueryValue)
    } else if (Array.isArray(routeQueryValue)) {
        routeQueryValue.forEach((item) => {
            if (typeof item === 'string' && item) candidates.push(item)
        })
    }

    for (const candidate of candidates) {
        const parsed = parseCustomOptionsString(candidate)
        if (parsed.length > 0) return parsed
    }

    return []
}

/**
 * Monta o array de custom_options no formato do carrinho para uma variation.
 */
export function buildCartCustomOptions(parsedEntries, shopifyVariationId) {
    if (!Array.isArray(parsedEntries) || !parsedEntries.length) return []

    const matched = []

    parsedEntries.forEach((entry) => {
        if (!variationIdsMatch(shopifyVariationId, entry.variationId)) return

        const existing = matched.find(
            (option) =>
                JSON.stringify(option, (key, value) =>
                    key === 'quantity'
                        ? undefined
                        : typeof value === 'string'
                          ? value.trim()
                          : value
                ) ===
                JSON.stringify(entry.options, (key, value) =>
                    typeof value === 'string' ? value.trim() : value
                )
        )

        if (existing) {
            existing.quantity = (existing.quantity || 1) + 1
        } else {
            matched.push({
                ...entry.options,
                quantity: 1,
            })
        }
    })

    return matched
}

function normalizeOptionKey(key) {
    return String(key || '')
        .normalize('NFD')
        .replace(/\p{Mn}/gu, '')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '')
}

export function normalizePersonName(value) {
    return String(value || '')
        .normalize('NFD')
        .replace(/\p{Mn}/gu, '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim()
}

export function namesMatch(a, b) {
    const left = normalizePersonName(a)
    const right = normalizePersonName(b)
    return !!left && !!right && left === right
}

function isNameOptionKey(key) {
    const k = normalizeOptionKey(key)
    return [
        'nome',
        'name',
        'nomecompleto',
        'fullname',
        'nomedocomprador',
        'nomedotitular',
        'nomedocliente',
    ].includes(k)
}

function isCpfOptionKey(key) {
    const k = normalizeOptionKey(key)
    return k === 'cpf' || k === 'cpfcnpj' || k === 'cnpj' || k === 'documento' || k === 'document' || k.includes('cpf')
}

function looksLikeDocument(value) {
    const digits = String(value || '').replace(/\D/g, '')
    return digits.length === 11 || digits.length === 14
}

function listCustomOptionObjects(item) {
    const raw = item?.custom_options
    if (!raw) return []
    if (Array.isArray(raw)) return raw.filter((option) => option && typeof option === 'object')
    if (typeof raw === 'string') {
        try {
            return listCustomOptionObjects({ custom_options: JSON.parse(raw) })
        } catch (_) {
            return []
        }
    }
    if (typeof raw === 'object') {
        const nested = Object.values(raw).filter(
            (value) => value && typeof value === 'object' && !Array.isArray(value)
        )
        return nested.length ? nested : [raw]
    }
    return []
}

/**
 * Pares nome/CPF extraídos das custom_options do carrinho (Shopify properties).
 */
export function extractNameDocumentPairsFromCart(cartItems = []) {
    const pairs = []
    ;(Array.isArray(cartItems) ? cartItems : []).forEach((item) => {
        listCustomOptionObjects(item).forEach((option) => {
            let name = ''
            let document = ''

            Object.entries(option).forEach(([key, value]) => {
                if (key === 'quantity' || value == null || value === '') return
                if (!name && isNameOptionKey(key)) name = String(value).trim()
                if (!document && isCpfOptionKey(key) && looksLikeDocument(value)) {
                    document = String(value).replace(/\D/g, '')
                }
            })

            if (!document) {
                Object.entries(option).forEach(([key, value]) => {
                    if (key === 'quantity' || isNameOptionKey(key)) return
                    if (!document && looksLikeDocument(value)) {
                        document = String(value).replace(/\D/g, '')
                    }
                })
            }

            if (name || document) pairs.push({ name, document })
        })
    })

    return pairs
}

export function findDocumentForName(pairs, name) {
    const list = Array.isArray(pairs) ? pairs.filter((pair) => pair && pair.document) : []
    if (!list.length) return ''

    const match = list.find((pair) => namesMatch(pair.name, name))
    if (match) return match.document
    if (list.length === 1) return list[0].document
    return ''
}

export function customerDocument(customer) {
    if (!customer || typeof customer !== 'object') return ''
    const raw = customer.cpf || customer.document || ''
    const digits = String(raw).replace(/\D/g, '')
    return looksLikeDocument(digits) ? digits : String(raw || '').trim()
}

export function saveCustomerX(values) {
    let customer = {
        id: this.$store.getters['getLead'].id ?? null,
        id_lead: this.$store.getters['getLead'].id_lead ?? null,
        id_account: this.$store.getters['getLead'].id_account ?? null,
        id_store: this.$store.getters['getLead'].id_store ?? null,
        hash: this.$store.getters['getLead'].customer.hash ?? null,
        hash_store: this.$store.getters['getLead'].hash,
        identify: this.$store.getters['getLead'].identify,
        name: values.name,
        email: values.email,
        phone_number: clearString(values.phone_number ?? ''),
        document: clearString(
            this.$store.getters['session/getData'].payment.document ?? ''
        ),
        zip_code: clearString(values.zip_code),
        street_name: values.street_name,
        number: values.number,
        complement: values.complement,
        neighborhood: values.neighborhood,
        city: values.city,
        state: values.state,
        src: this.$store.getters['session/getTracking'].src ?? "",
        last_contents: this.$store.getters['cart/getCart'] ?? null,
    }
    // this.$store.commit('setLead', customer)
}
